import { gql } from '@apollo/client';

export const GET_INTERVENTION = gql`
  query GetIntervention($id: ID!) {
    intervention: getIntervention(id: $id) {
      id
      name
      description
      theoryOfChange
      treatmentGroup {
        id
        name
      }
      beneficiaries {
        id
        name
      }
      peopleProfiles {
        id
        role
      }
      type: interventionType {
        id
        name
      }
      grades {
        id
        name
      }
      subjects {
        id
        name
        subjectGradeReference
      }
      focus {
        id
        name
      }
      focusSubjects {
        id
        name
      }
      accredited
      accreditation
      endorsed
      endorsement
      programme {
        id
        name
      }
      phase {
        id
        name
      }
      fromDate
      toDate
      isInternal
      cohorts {
        id
        name
      }
      otherBeneficiaries {
        id
        name
      }
      otherTreatmentGroups {
        id
        name
      }
      institutions {
        id
        role
      }
      budgetedAmount
      receivedAmount
      spentAmount
      overallTime
      treatmentTime
      inputs {
        id
        description
        quantity
        category {
          id
          name
        }
        type {
          id
          name
        }
        frequencyType {
          id
          name
        }
        frequency {
          id
          name
        }
        frequencyInt
        distributed
        retrieved
        utilizationTracking
      }
      activities {
        id
        activityTargets {
          id
          endDate
          groupingType
          numberOfSessions
          expectedNumberOfAttendees
          plannedDuration
          startDate
          cohort {
            id
            name
          }
          frequency {
            id
            name
          }
          frequencyType {
            id
            name
          }
          institution {
            id
            name
          }
        }
        audienceSize {
          id
          name
        }
        audienceType {
          id
          name
        }
        cohorts {
          id
          name
        }
        description
        groupingType
        guestsAreTracked
        sessionBasedAttendees
        inputTypes {
          id
          name
          quantity {
            quantity
          }
        }
        inputs {
          id
          description
          quantity
          type {
            id
            name
          }
        }
        institutions {
          id
          name
        }
        interfaceType {
          id
          name
        }
        multiDay
        name
        numberOfDays
        weeklyTracking
        weekStartDay
        numberOfDaysPerWeek
        sunday
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        historicalData
        renderGroupForm
        stakeholderTypes {
          id
          name
        }
        substitutesAreAllowed
        subjects {
          id
          name
          subjectGradeReference
        }
        targetAudiences {
          id
          name
        }
        targetGroup {
          id
          name
        }
        totalNumberOfSessions
        trackingLevel
        type {
          id
          name
        }
      }
      geographies {
        id
        name
      }
      frameworkType {
        id
        name
        levels {
          id
          name
          level
          allowIndicators
        }
      }
      frameworkResults {
        id
        type
        number
        description
        default {
          id
        }
        level {
          id
          level
        }
        parentResult {
          id
        }
        indicators {
          id
          measurementUnit
          type
          unit
          name
          startDate
          endDate
          target
          targetValue
          description
          resultRelationship
          hasTargets
          hasBaseline
          minValueAllowed
          maxValueAllowed
          dataSources
          timeline
          trackProgressStatus
          statusTier
          statusType
          outcomeTheme {
            id
            name
          }
          period {
            id
            name
          }
          dimensions {
            id
            index
            name
            options
          }
          benchmarks {
            id
            index
            name
            description
            benchmark {
              id
              name
              description
            }
          }
          periods {
            id
            periodDate
            periodNumber
            label
          }
          targets {
            id
            value
            periodDate
            periodNumber
            dimensionOptions
          }
          trackingHierarchy {
            id
            name
          }
          trackingHierarchyLevel {
            id
            typeOfSite
            value
          }
        }
      }
      owner {
        id
        firstName
        lastName
      }
      # sites {
      #   id
      #   name
      #   indicator {
      #     id
      #     name
      #   }
      # }
      reporters {
        id
        assignee {
          id
          firstName
          lastName
        }
        organisation {
          id
          isFunder
          isInstitution
          isServiceProvider
          funder {
            id
            name
          }
          serviceProvider {
            id
            name
          }
          institution {
            id
            name
          }
        }
      }
      theoryOfChangeFile {
        id
      }
      currency
      addOns {
        id
        name
      }
      monitoringForms {
        id
        name
        description
        captureValue
        version
        published
        period {
          id
          name
        }
        indicators {
          id
          indicator {
            id
            name
            period {
              id
              name
            }
            frameworkResult {
              id
            }
            trackingHierarchy {
              id
              name
            }
            trackingHierarchyLevel {
              id
              typeOfSite
              value
            }
          }
          dimensions
        }
        reporters {
          id
          funder {
            id
            name
          }
          institution {
            id
            name
          }
          serviceProvider {
            id
            name
          }
        }
        formReporters {
          id
          organisation {
            id
            funder {
              id
              name
            }
            institution {
              id
              name
            }
            serviceProvider {
              id
              name
            }
          }
        }
        users {
          id
          organisation {
            id
            isFunder
            isInstitution
            isServiceProvider
            funder {
              id
              name
            }
            serviceProvider {
              id
              name
            }
            institution {
              id
              name
            }
          }
          user {
            id
            organisations {
              id
              organisation {
                id
                isFunder
                isInstitution
                isServiceProvider
                funder {
                  id
                  name
                }
                serviceProvider {
                  id
                  name
                }
                institution {
                  id
                  name
                }
              }
            }
            firstName
            lastName
            funder {
              id
              name
            }
            institution {
              id
              name
            }
            serviceProvider {
              id
              name
            }
          }
          formRole {
            id
            name
          }
        }
        dueDates {
          id
          date
          periodNumber
        }
        associatedForms {
          id
          name
          published
        }
        associatedActivities {
          id
          name
          intervention {
            id
            name
          }
        }
        sites {
          id
          site {
            id
            name
          }
          indicator {
            id
            name
          }
          hierarchyLevel {
            id
            typeOfSite
          }
        }
        supportingDocuments
      }
    }
  }
`;
